// features/quickPricer/quickPricerFormSlice.js
import { createSlice } from "@reduxjs/toolkit";
import { QUICK_PRICER_FORM_CONFIG } from "../../components/quick-pricer-form/quickPricer.form.config";

const buildInitialState = () => {
  const state = {};

  QUICK_PRICER_FORM_CONFIG.sections.forEach((section) => {
    section.fields.forEach((field) => {
      state[field.name] =
        field.defaultValue !== undefined ? field.defaultValue : "";
    });
  });

  return state;
};

const initialState = {
  formData: buildInitialState()
};

const quickPricerFormSlice = createSlice({
  name: "quickPricerForm",
  initialState,
  reducers: {
    setFormField: (state, action) => {
      const { name, value } = action.payload;
      state.formData[name] = value;
    },

    setFormData: (state, action) => {
      state.formData = action.payload;
    },

    resetForm: (state) => {
      state.formData = buildInitialState();
    }
  }
});

export const {
  setFormField,
  setFormData,
  resetForm
} = quickPricerFormSlice.actions;

export default quickPricerFormSlice.reducer;